/**
 * Cancel Geolocation
 *
 * If 'Turn Off Location' is clicked, remove.
 */
export default function electionCancelGeolocation() {
  // console.log('I am loading - geolocation.js - Cancelling');

  const locationCancelTriggers = document.getElementsByClassName("geolocation-cancel");
  const triggerArray = Array.from(locationCancelTriggers).entries();
  let jumpToBlock = document.getElementsByClassName('location__jump-to-container')[0]; // Only a single Jump-To box.

  for (let [index, trigger] of triggerArray) {

    const cancelGeoLocation = () => {
      // Clear Banner Content.
      geoLocationElement = document.getElementById('geolocation-found');
      geoLocationElement.innerHTML = "";

      // Hide 'location__banner--located'.
      defaultLocationBanner = document.getElementsByClassName("location__banner--located");
      defaultLocationBanner[0].style.display = "none";
      // Show 'location__banner--default' and the 'Jump To' banner.
      defaultLocationBanner = document.getElementsByClassName("location__banner--default");
      defaultLocationBanner[0].style.display = "flex";
      const jumpToBanner = document.querySelector(".location__jump-to-container");
      jumpToBanner.style.display = "block";

      // TODO: Clear LocalStorage / Cookie.

      // console.log('I am loading - geolocation.js - Fully Cancelled');
    }

    trigger.addEventListener("click", cancelGeoLocation);
  }
}
